import Icon, { DeleteOutlined, DownloadOutlined, LoadingOutlined } from '@ant-design/icons';
import { useTranslate } from '@tolgee/react';
import { Button, Spin } from 'antd';
import { UploadFile } from 'antd/es/upload/interface';
import { IActiveParseResultRsp } from 'services/api/oms';
import { ReactComponent as excelSvg } from 'views/Setting/assets/excel.svg';

interface UploadFileResultProps {
  scenarioType: Marketing.StockoutScenarioType;
  fileList: UploadFile<any>[];
  parseRst?: IActiveParseResultRsp;
  action: OutofStock.Action;
  onClick: () => void;
}

export const UploadFileResult = (props: UploadFileResultProps) => {
  const { scenarioType, fileList, parseRst, action, onClick } = props;
  const { t } = useTranslate();

  return (
    <>
      <div className="py-4 px-7 flex items-center border border-dashed border-[#eee]">
        {!parseRst ? (
          <Spin
            className="!flex-shrink-0"
            indicator={<LoadingOutlined style={{ fontSize: 32 }} spin />}
          />
        ) : (
          <Icon className="!flex-shrink-0 text-[32px]" component={excelSvg} />
        )}
        <div className="mx-4 flex flex-col flex-1">
          <span>{fileList[0].name}</span>
          {parseRst && parseRst.planned > 0 ? (
            <span style={{ marginTop: '4px' }}>
              {scenarioType === 'OUT_STOCK_REMINDER' &&
                t('aide.预计提醒任务数', { num: parseRst.planned })}
              {scenarioType === 'ORDER_FOLLOWUP' &&
                t('预计发送消息订单数', { num: parseRst.planned })}
            </span>
          ) : null}
        </div>
        <Button type="text" disabled={action === 'view'} onClick={onClick}>
          <DeleteOutlined className="flex-shrink-0 text-base" />
        </Button>
      </div>
      {parseRst ? (
        <div className="flex flex-col items-start">
          {parseRst.errorCount > 0 && parseRst.planned > 0 ? (
            <span className="pt-1 text-[#F2A100]">
              {t('aide.任务解析部分错', { num: parseRst.errorCount })}
            </span>
          ) : null}
          {parseRst.planned === 0 ? (
            <span className="pt-1 text-[#F05B5B]">{t('outstock_upload_error_tips')}</span>
          ) : null}
          {parseRst.status === 'FAILED' ? (
            <span className="pt-1 text-[#F05B5B]">
              {t('aide.任务解析出错', { num: parseRst.errorCount })}
            </span>
          ) : null}
          {parseRst.errorCount > 0 ? (
            <Button type="link" className="!p-0" href={parseRst.errorUrl}>
              <DownloadOutlined /> {t('aide.下载表格')}
            </Button>
          ) : null}
        </div>
      ) : null}
    </>
  );
};
